/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';

const messages = defineMessages({
	unknown: {id: 'Merk.magnitude.unknown', 'defaultMessage': 'Unknown'},
	noEmployees: {id: 'Merk.magnitude.noEmployees', 'defaultMessage': 'Without employees'},
	employeesRange: {id: 'Merk.magnitude.employeesRange', 'defaultMessage': '{lower_bound_val, number} - {upper_bound_val, number} employees'},
	employeesRangeCeiling: {id: 'Merk.magnitude.employeesRangeCeiling', 'defaultMessage': '{lower_bound_val, number} and more employees'},
});

class MerkMagnitude extends React.Component {
	static propTypes = {
        data: PropTypes.object.isRequired,
		intl: PropTypes.object.isRequired,
    };

	constructor(props) {
        super(props);
    }

	render() {
		let text = messages.unknown;
		let directMsg = null;

		if (this.props.data) {
            if (typeof this.props.data.upper_bound_val === "number" && this.props.data.upper_bound_val === 0) {
                text = messages.noEmployees;
            }
            else if (typeof this.props.data.lower_bound_val === "number" && typeof this.props.data.upper_bound_val === "number") {
                text = messages.employeesRange;
            }
            else if (typeof this.props.data.lower_bound_val === "number" && typeof this.props.data.upper_bound_val !== "number") {
                text = messages.employeesRangeCeiling;
            } else if (this.props.data.text) {
                directMsg = this.props.data.text;
            }
        }

        let args = {
            'lower_bound_val': this.props.data.lower_bound_val,
            'upper_bound_val': this.props.data.upper_bound_val,
        };

        return (
            <span className="dativeryValue">{directMsg ? directMsg : this.props.intl.formatMessage(text, args)}</span>
        );
    }
}

export default injectIntl(MerkMagnitude);
